var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4013 20.2547C6.94083 18.8192 9.87475 18 13 18C16.1253 18 19.0592 18.8192 21.5987 20.2547M16.75 10.5C16.75 12.5711 15.0711 14.25 13 14.25C10.9289 14.25 9.25 12.5711 9.25 10.5C9.25 8.42893 10.9289 6.75 13 6.75C15.0711 6.75 16.75 8.42893 16.75 10.5ZM24.25 13C24.25 19.2132 19.2132 24.25 13 24.25C6.7868 24.25 1.75 19.2132 1.75 13C1.75 6.7868 6.7868 1.75 13 1.75C19.2132 1.75 24.25 6.7868 24.25 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlaceholder);
export default __webpack_public_path__ + "static/media/ic-placeholder.8832609bc83071b357a0a1d8bda9e02d.svg";
export { ForwardRef as ReactComponent };